<template>
  <div class="columns is-centered pt-6">
    <div class="column is-narrow">
      <img class="cc-loader-img-small" src="@/assets/gears.svg" alt="Gears spinning while loading page">
    </div>
  </div>
</template>
<script>
export default {
  name: 'ccLoadingComponent',
  data () {
    return {}
  },
  methods: {}
}
</script>
